import UserIdentity from './userIdentity/UserIdentity.vue'
import UserCommunities from './userCommunities/UserCommunities.vue'
import NotificationsSetup from './notificationsSetup/NotificationsSetup.vue'
import config from '../../config'
import ReadAboutIcon from 'vue-material-design-icons/InformationOutline.vue'
import TermsIcon from 'vue-material-design-icons/BookOpenVariant.vue'

export default {
  name: 'PersoInfo',
  components: { TermsIcon, UserIdentity, UserCommunities, NotificationsSetup, ReadAboutIcon },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  async created() {
    return Promise.all([
      // await this.$store.dispatch('fetchSkills'),
      await this.$store.dispatch('fetchInterests'),
      await this.$store.dispatch('fetchLanguages'),
      await this.getUserInfo()
    ])
  },
  watch: {
    '$route'() {
      this.getUserInfo()
    }
  },
  computed: {
    user() {
      return this.$store.getters.userInfo || {}
    },
    interests() {
      return this.user.interests || []
    },
    languages() {
      return this.user.languages || []
    },
    skills() {
      return this.user.skills || []
    },
    communities() {
      if (!this.user.communities) {
        return []
      }
      return [...this.user.communities].sort(function (a, b) {
        return a && b && a.name && b.name && a.name.localeCompare(b.name)
      })
    },
    isCurrentUser() {
      return this.$store.getters.userInfo.id === this.$store.getters.currentUserId
    },
    feedbackUrl() {
      return config.FEEDBACK_URL
    }
  },
  methods: {
    async getUserInfo() {
      return this.$store.dispatch('fetchUserById', this.id)
        .catch(() => {
          this.$router.push({ name: 'notFound', params: { component: 'user' } })
        })
    },
    sort(list) {
      return list.sort((a, b) => {
        return a && b && a.toLowerCase().localeCompare(b.toLowerCase())
      })
    },
    goToAbout() {
      this.$router.push({ name: 'about' })
    },
    goToConditions() {
      this.$router.push({ name: 'agreement' })
    }
  }
}
